export const application = 'bright-prod';

export const apiURL = '/bright/api';

export const academyURL = 'https://learnwithbright.academy';

export const gaId = 'G-HGWRZTGYH7';

export const vimeoURL = 'https://vimeo.com/api/oembed.json?url=https%3A//vimeo.com';
